
/* eslint-disable max-classes-per-file */

import { SimpleSelectionItem } from "../components/selector/simple-selection-item";

/**
 * Nycklar för webinställningar. Måste matcha validering i BLL för att kunna användas.
 */
export class WebInstallning {
    static readonly MeddelandeInfotavla = "MeddelandeInfotavla";
    static readonly PlaneraFilter = "Planera.filter";
    static readonly PlaneraMapLayerFilter = "Planera.maplayers";
    static readonly PlaneraProduktionsmalPlanFilter = "Planera.produktionsmalPlanFilter";
    static readonly VirkeskopMapLayerFilter = "Virkeskop.maplayers";
    static readonly JusteraLeveransplanKundorderfilter = "JusteraLeveransplan.kundorderfilter";
    static readonly JusteraLeveransplanLeverantorsorderfilter = "JusteraLeveransplan.leverantorsorderfilter";
    static readonly JusteraLeveransplanProduktionsomradefilter = "JusteraLeveransplan.produktionsomradefilter";
    static readonly ProduktionsmalFilter = "Produktionsmal.searchFilter";
    static readonly VirkeskopPristabellMarknadsprislistaFilter = "Virkeskop.Pristabell.marknadsprislistaFilter";
    static readonly SenastAnvandaIFalt = "SenastAnvandaIFalt";
    static readonly VirkeskopKartaInstallning = "Virkeskop.Karta.Installning";
    static readonly VirkeskopKontraktsutskriftInstallning = "Virkeskop.Kontraktsutskrift.Installning";
    static readonly HandelssortimentSearchParams = "Handelssortiment.searchparams";
}

export class Produktionsstatus {
    static readonly ProduktionEjPaborjad = "Produktion ej påbörjad";
    static readonly ProduktionPagar = "Produktion pågår";
    static readonly ProduktionAvslutad = "Produktion avslutad";
    static readonly Slutrapporterad = "Slutrapporterad";
    static readonly ProduktionGodkand = "Produktion godkänd";
    static readonly Makulerad = "Makulerad";
}

export class KundorderTyp {
    static readonly Kundorder = "KUND";
    static readonly Terminalorder = "TERMINAL";
}

export class Mattslag {
    static readonly M3MIUB = "m3miub";
    static readonly M3TOUB = "m3toub";
    static readonly M3TO = "m3to";
    static readonly M3FUB = "m3fub";
    static readonly M3F = "m3f";
    static readonly M3S = "m3s";
    static readonly TON = "ton";
    static readonly ST = "st";
    static readonly TTV = "ttv";
    static readonly M3 = "m3";
    static readonly MWH = "MWh";
    static readonly AllaViol3Mattslag: string[] = [
        Mattslag.M3MIUB,
        Mattslag.M3TOUB,
        Mattslag.M3TO,
        Mattslag.M3FUB,
        Mattslag.M3F,
        Mattslag.TON,
        Mattslag.ST,
        Mattslag.TTV,
        Mattslag.M3,
        Mattslag.MWH
    ];
}

export class MatTyper {
    static readonly Stockmatning = "Stockmätning";
    static readonly Travmatning = "Travmätning";
    static readonly alla: string[] = [
        MatTyper.Stockmatning,
        MatTyper.Travmatning
    ];
}

export class Distriktstyp {
    static readonly Lan = "Lan";
    static readonly Kommun = "Kommun";
    static readonly Distrikt = "Distrikt";
}

export class DynamicFeatureLayer {
    // Layer: Atgarder
    static readonly Atgarder = "Åtgärder";
    // Layer: Atgarder_selection
    static readonly AtgarderSelection = "Åtgärder (urval)";
    // Layer: Atgarder_selection, sublayers (Avverkningsåtgärder)
    static readonly AtgarderSelection_Avverkningsatgarder = "Avverkningsåtgärder";
    // Layer: Virkeskop
    static readonly Virkeskop = "Virkesköp";
}

export class DynamicFeatureLayerSetting {
    static readonly AtgarderSelection_Avverkningsatgarder_AtgardGuidProperty = "GUID";
    static readonly Virkeskop_Virkeskopskontrakt_GUIDProperty = "Virkeskopskontrakt_GUID";
    static readonly Arbetsorder_ArbetsorderStatusProperty = "ArbetsorderStatus";
}

export class SenastAnvandaIFalt {
    static readonly Kundnamn = "Kundnamn";
    static readonly MottagningsplatsKundorder = "MottagningsplatsKundorder";
    static readonly MottagningsplatsTerminalorder = "MottagningsplatsTerminalorder";
    static readonly Handelssortiment = "Handelssortiment";
    static readonly Leverantorsnamn = "Leverantorsnamn";
}

export class RaskRoller {
    static readonly role = {
        Administrera: "RASK.Administrera",
        Kundhantera: "RASK.Kundhantera",
        Prislisteadministrera: "RASK.Prislisteadministrera",
        Produktinstruktionsadmininstrera: "RASK.Produktinstruktionsadmininstrera",
        Produktadministrera: "RASK.Produktadministrera",
        Produktionsleda: "RASK.Produktionsleda",
        Kopleda: "RASK.Kopleda",
        Systemadministrera: "RASK.Systemadministrera",
        Titta: "RASK.Titta",
        Virkeskopa: "RASK.Virkeskopa",
        Kopplanera: "RASK.Kopplanera",
        Arbetsordersystemadmin: "RASK.Arbetsordersystemadmin",
        Certifikatsadministrera: "RASK.Certifikatsadministrera",
        Virkesekonomiadministrera: "RASK.Virkesekonomiadministrera",
        Skogsvardsuppdragsplanera: "RASK.Skogsvardsuppdragsplanera",
        Avverkningsplanera: "RASK.Avverkningsplanera",
        VirkeskopTitta: "RASK.VirkeskopTitta"
    };
}

export class VirkeskopAffarsformer {
    static readonly Rotpost = "Rotpost"; // u2
    static readonly Leveransvirke = "Leveransvirke"; // u3
    static readonly AuFastKostnad = "AU fast kostnad"; // u4
    static readonly AuSjalvkostnad = "AU självkostnad"; // u5
    static readonly Leveransrotkop = "Leveransrotköp"; // u6
    static readonly Alla: string[] = [
        VirkeskopAffarsformer.Rotpost,
        VirkeskopAffarsformer.Leveransvirke,
        VirkeskopAffarsformer.AuFastKostnad,
        VirkeskopAffarsformer.AuSjalvkostnad,
        VirkeskopAffarsformer.Leveransrotkop
    ];

    static readonly RotpostForShort = "U2";
    static readonly LeveransvirkeForShort = "U3";
    static readonly AuFastKostnadForShort = "U4";
    static readonly AuSjalvkostnadForShort = "U5";
    static readonly LeveransrotkopForShort = "U6";
    static readonly AllaWithShortType: { key: string; value: string }[] = [
        {
            key: VirkeskopAffarsformer.RotpostForShort,
            value: VirkeskopAffarsformer.Rotpost
        },
        {
            key: VirkeskopAffarsformer.LeveransvirkeForShort,
            value: VirkeskopAffarsformer.Leveransvirke
        },
        {
            key: VirkeskopAffarsformer.AuFastKostnadForShort,
            value: VirkeskopAffarsformer.AuFastKostnad
        },
        {
            key: VirkeskopAffarsformer.AuSjalvkostnadForShort,
            value: VirkeskopAffarsformer.AuSjalvkostnad
        },
        {
            key: VirkeskopAffarsformer.LeveransrotkopForShort,
            value: VirkeskopAffarsformer.Leveransrotkop
        }
    ];
}

export class VirkeskopNettotyper {
    static readonly Sortimentsnetto = "Sortimentsnetto";
    static readonly Snittnetto = "Snittnetto";
}

export class VirkeskopskontraktPrisTyper {
    static readonly Handelssortiment = "Handelssortiment";
    static readonly Handelssortimentgrupp = "Handelssortimentgrupp";
    static readonly Snittnetto = "Snittnetto";
}

export class VirkeskopskontraktPrisBerakningsTyper {
    static readonly Prislista = "Prislista";
    static readonly Sortimentsnetto = "Sortimentsnetto";
    static readonly Prislistehanvisning = "Prislistehanvisning";
}

export class VirkeskopAtgardsgrupper {
    static readonly Avverkning = "Avverkning";
    static readonly Leveransvirke = "Leveransvirke";
    static readonly Grot = "Grot";
}

export class VirkeskopAvverkningskostnadstyp {
    static readonly Skordning = "Skördning";
    static readonly Skotning = "Skotning";
    static readonly Drivning = "Drivning";
    static readonly VagarAvlagg = "Vägar/Avlägg";
    static readonly Flytt = "Flytt";
    static readonly Ovrigt = "Övrigt";
}

export class Operationstyper {
    static readonly Skordning = "Skördning";
    static readonly Skotning = "Skotning";
    static readonly Grotskotning = "Grotskotning";
}

export class ValsSynkroniseringsstatusTyp {
    static readonly Skickad = "Skickad";
    static readonly Fel = "Fel";
    static readonly Mottagen = "Mottagen";
}

export class Planeringsstatus {
    static readonly Tillgangligt = "Tillgängligt";
    static readonly Fardigplanerat = "Färdigplanerat";
    static readonly UnderPlanering = "Under planering";
    static readonly Utfort = "Utfört";
    static readonly Ajourhallet = "Ajourhållet";
}

export class Barighetsklasser {
    static readonly BK1 = "BK1";
    static readonly BK2 = "BK2";
    static readonly BK3 = "BK3";
    static readonly BK4 = "BK4";
}

export class ForsorjningskallaTyp {
    static readonly Produktionsomrade = "PRODUKTIONSOMRADE";
    static readonly Terminal = "TERMINAL";
    static readonly Leverantorsorder = "LEVERANTORSORDER";
}

export class Maskinlagstyp {
    static readonly Grot = "Grot";
    static readonly Normal = "Normal";
    static readonly drivare = "Drivare";
    static readonly EttPlusTva = "1+2";
    static readonly TvaPlusEtt = "2+1";
}

export class VirkesorderStatus {
    static readonly Ny = "N";
    static readonly Sand = "S";
    static readonly Pagaende = "P";
    static readonly Aktiv = "A";
    static readonly FelLoadTender = "F";
    static readonly FelContract = "FV";
    static readonly Makulerad = "M";

    static readonly Virkesorderstatusar: { key: string; value: string }[] = [
        {
            key: "",
            value: "Saknas"
        },
        {
            key: VirkesorderStatus.Ny,
            value: "Utkast"
        },
        {
            key: VirkesorderStatus.Sand,
            value: "Pågående"
        },
        {
            key: VirkesorderStatus.Pagaende,
            value: "Pågående"
        },
        {
            key: VirkesorderStatus.Aktiv,
            value: "Aktiv"
        },
        {
            key: VirkesorderStatus.FelLoadTender,
            value: "Fel"
        },
        {
            key: VirkesorderStatus.FelContract,
            value: "Fel"
        },
        {
            key: VirkesorderStatus.Makulerad,
            value: "Avslutad"
        }
    ];

    static readonly Felstatusar = [
        VirkesorderStatus.FelLoadTender,
        VirkesorderStatus.FelContract
    ];

    static VirkesorderStatusIconStyle(status: string) {
        let icon: string;
        let color: string;

        if (status === VirkesorderStatus.Ny || status === VirkesorderStatus.Pagaende || status === VirkesorderStatus.Sand) {
            icon = VirkesorderIcons.minusCirkel;
            color = "gray";
        } else if (status === VirkesorderStatus.Aktiv) {
            icon = VirkesorderIcons.checkCirkel;
            color = "green";
        } else if (status === VirkesorderStatus.FelLoadTender || status === VirkesorderStatus.FelContract) {
            icon = VirkesorderIcons.faTimesCirkel;
            color = "red";
        } else {
            icon = VirkesorderIcons.faCirkel;
            color = "gray";
        }

        return {
            icon: icon,
            color: color
        };
    }

    static VirkesorderStatusIconStyleViol3(
        hasTransmissionErrorProduktionViol3: boolean,
        hasTransmissionErrorTransportViol3: boolean,
        dirtyProduktionsdel: boolean,
        dirtyTransportdel: boolean,
        skickadTillViol3: boolean) {
        // eslint-disable-next-line sonarjs/no-unused-vars
        let icon: string;
        // eslint-disable-next-line sonarjs/no-unused-vars
        let color: string;

        if (hasTransmissionErrorProduktionViol3 || hasTransmissionErrorTransportViol3) {
            return Viol3Status.Viol3StatusIconStyle(Viol3Status.Fel);
        } else if ((dirtyProduktionsdel || dirtyTransportdel) && skickadTillViol3) {
            return Viol3Status.Viol3StatusIconStyle(Viol3Status.AktivUppdateras);
        } else if (skickadTillViol3) {
            return Viol3Status.Viol3StatusIconStyle(Viol3Status.Aktiv);
        } else {
            return Viol3Status.Viol3StatusIconStyle(Viol3Status.Ny);
        }
    }
}
export class VirkesorderIcons {
    static readonly minusCirkel = "fa-minus-circle";
    static readonly checkCirkel = "fa-check-circle";
    static readonly faTimesCirkel = "fa-times-circle";
    static readonly faCirkel = "fa-circle";
}
export class Viol3Status {
    static readonly Ny = "N";
    static readonly Aktiv = "A";
    static readonly AktivUppdateras = "U";
    static readonly Fel = "F";
    static readonly Makulerad = "M";

    static Viol3StatusIconStyle(status: string) {
        let icon: string;
        let color: string;
        if (status === Viol3Status.AktivUppdateras) {
            icon = VirkesorderIcons.minusCirkel;
            color = "gray";
        } else if (status === Viol3Status.Aktiv) {
            icon = VirkesorderIcons.checkCirkel;
            color = "green";
        } else if (status === Viol3Status.Fel) {
            icon = VirkesorderIcons.faTimesCirkel;
            color = "red";
        } else if (status === Viol3Status.Makulerad) {
            icon = VirkesorderIcons.faTimesCirkel;
            color = "gray";
        } else {
            icon = VirkesorderIcons.faCirkel;
            color = "gray";
        }

        return {
            icon: icon,
            color: color
        };
    }

}
export class VirkesorderRadStatus {
    static readonly Vilande = "Vilande";
    static readonly Klar = "Klar";
}

export class VerksamhetshandelseTyp {
    static readonly Arbetsorder = "Arbetsorder";
    static readonly Virkeskop = "Virkesköp";
    static readonly Kundorder = "Kundorder";
}

export class Verksamhetshandelse {
    static readonly KopieraHandelssortimentFromKontrakt = "KopieraHandelssortimentFromVirkeskop";
    static readonly HamtaDrivningspunkterFranVirkeskopskontrakt = "HamtaDrivningspunkterFranVirkeskopskontrakt";
    static readonly Utbytessimulerad = "Utbytessimulerad";
}

export class Handelssortimentsgrupp {
    static readonly OvrigtBarrtimmer = "Övrigt barrtimmer";
    static readonly Talltimmer = "Talltimmer";
    static readonly Grantimmer = "Grantimmer";
    static readonly KlentimmerBarr = "Klentimmer barr";
    static readonly Lovtimmer = "Lövtimmer";
    static readonly Barrmassaved = "Barrmassaved";
    static readonly Lovmassaved = "Lövmassaved";
    static readonly Energived = "Energived";
    static readonly Grot = "Grot";
    static readonly Stubbar = "Stubbar";
    static readonly Traddelar = "Träddelar";
    static readonly Ovrigt = "Övrigt";
    static readonly KlentimmerTall = "Klentimmer tall";
    static readonly KlentimmerGran = "Klentimmer gran";
}

export class Produktgrupp {
    static readonly OvrigtBarrtimmer = "Övrigt barrtimmer";
    static readonly Talltimmer = "Talltimmer";
    static readonly Grantimmer = "Grantimmer";
    static readonly Lovtimmer = "Lövtimmer";
    static readonly Lovmassaved = "Lövmassaved";
    static readonly Granmassaved = "Granmassaved";
    static readonly Energived = "Energived";
    static readonly Grot = "Grot";
    static readonly Stubbar = "Stubbar";
    static readonly Traddelar = "Träddelar";
    static readonly Ovrigt = "Övrigt";
    static readonly KlentimmerTall = "Klentimmer tall";
    static readonly KlentimmerGran = "Klentimmer gran";
    static readonly BarrmassavedTallOchGran = "Barrmassaved (tall och gran)";
    static readonly OvrigBarrmassaved = "Övrig barrmassaved";
    static readonly Contortatimmer = "Contortatimmer";
    static readonly Larktimmer = "Lärktimmer";
    static readonly Oklass = "Oklass";
}

export class TradslagKortnamn {
    static readonly Al = "Al";
    static readonly Alm = "Alm";
    static readonly Ask = "Ask";
    static readonly Asp = "Asp";
    static readonly Bjork = "Björk";
    static readonly Bok = "Bok";
    static readonly Cont = "Cont";
    static readonly Ek = "Ek";
    static readonly Exba = "Exba";
    static readonly Exlv = "Exlv";
    static readonly Gran = "Gran";
    static readonly Lind = "Lind";
    static readonly Lark = "Lärk";
    static readonly Lonn = "Lönn";
    static readonly Ronn = "Rönn";
    static readonly Salg = "Sälg";
    static readonly Tall = "Tall";
    static readonly Olov = "Ölöv";
}

export class TradslagExternkod {
    static readonly Tall = "Tall";
    static readonly Gran = "Gran";
    static readonly Bjork = "Björk";
    static readonly Contorta = "Contorta";
    static readonly Bok = "Bok";
    static readonly Ek = "Ek";
    static readonly Al = "Al";
    static readonly Alm = "Alm";
    static readonly Ask = "Ask";
    static readonly Asp = "Asp";
    static readonly Lark = "Lärk";
    static readonly Lind = "Lind";
    static readonly Lonn = "Lönn";
    static readonly Ronn = "Rönn";
    static readonly Salg = "Sälg";
    static readonly Ovrigtlov = "Övrigt löv (ej exot)";
    static readonly Exotiskbarr = "Exotisk barr";
    static readonly Exotisklov = "Exotisk löv";
    static readonly SibiriskLark = "Sibirisk lärk";
    static readonly HybridLark = "Hybridlärk";
}

export class SkogsvardPlanteringPlantskyddMetoder {
    static readonly ja = "Ja";
    static readonly nej = "Nej";
    static readonly conniflex = "Conniflex";
}

export class SkogsvardPlanttyper {
    static readonly barrotLiten = "Barrot Liten";
    static readonly barrotMedelstor = "Barrot Medelstor";
    static readonly barrotStor = "Barrot Stor";
    static readonly barrotXstor = "Barrot Xstor";

    static readonly tackrotLiten = "Täckrot Liten";
    static readonly tackrotMedelstor = "Täckrot Medelstor";
    static readonly tackrotStor = "Täckrot Stor";
    static readonly tackrotXstor = "Täckrot Xstor";
    static readonly tePlus = "TePlus";
}

export class SkogsvardMattillfallen {
    static readonly foreAtgard = "Före åtgärd";
    static readonly beraknatKvar = "Beräknat kvar";
}

export class SkogsvardStatus {
    static readonly ny = "Ny";
    static readonly planerbar = "Planerbar";
    static readonly planering = "Planering";
    static readonly tilldelad = "Tilldelad";
    static readonly delgiven = "Delgiven";
    static readonly tillganglig = "Tillgänglig";
    static readonly utford = "Utförd";
    static readonly slutrapporterad = "Slutrapporterad";
    static readonly godkand = "Godkänd";
    static readonly ajourhallen = "Ajourhållen";
    static readonly ejGodkand = "Ej godkänd";
    static readonly ejUtford = "Ej utförd";
    static readonly borttagen = "Borttagen";
}

export class SenastAnvandaPrislistorFilterValues {
    static readonly VLG = "VLG";
    static readonly IckeVLG = "Icke VLG";
    static readonly SenastAnvanda = "Senast använda";
}

export class Anskaffningsformer {
    static readonly Egenskog = "Egen skog";
    static readonly Virkeskop = "Virkesköp";
    static readonly Import = "Import";
    static readonly EgenTerminal = "Egen terminal";
    static readonly CentralaKop = "Centrala köp";
    static readonly CentralaVirkeskop = "Centrala virkesköp";
    static readonly AllaProduktion: string[] = [
        Anskaffningsformer.Egenskog,
        Anskaffningsformer.Virkeskop
    ];

    static readonly ExternArbetsorderAnskaffningsformer: string[] = [
        Anskaffningsformer.CentralaKop,
        Anskaffningsformer.Import,
        Anskaffningsformer.EgenTerminal
    ];

    static readonly Alla: string[] = [
        Anskaffningsformer.Egenskog,
        Anskaffningsformer.Virkeskop,
        Anskaffningsformer.Import,
        Anskaffningsformer.EgenTerminal,
        Anskaffningsformer.CentralaVirkeskop
    ];

    static readonly VirkeskopAnksaffningsFormer: string[] = [
        Anskaffningsformer.Virkeskop,
        Anskaffningsformer.CentralaVirkeskop
    ];

    static readonly AllaRegelverk: string[] = [
        Anskaffningsformer.Egenskog,
        Anskaffningsformer.Virkeskop,
        Anskaffningsformer.CentralaVirkeskop
    ];

    static readonly AllaRegelverkViol3: string[] = [
        Anskaffningsformer.Egenskog,
        Anskaffningsformer.Virkeskop,
        Anskaffningsformer.CentralaVirkeskop,
        Anskaffningsformer.Import,
        Anskaffningsformer.EgenTerminal
    ];

    static isVirkesKop(anskaffningsform: string): boolean {
        return this.VirkeskopAnksaffningsFormer.some(x => x === anskaffningsform);
    }
}

export class Avverkningsformer {
    static readonly Foryngringsavverkning = "Föryngringsavverkning";
    static readonly ForyngringsavverkningKod = "F";
    static readonly Gallring = "Gallring";
    static readonly GallringKod = "G";
    static readonly Okand = "Okänd";
    static readonly OkandKod = "O";
    static readonly OvrigAvverkning = "Övrig avverkning";

    static readonly Alla: any[] = [
        {
            namn: Avverkningsformer.Foryngringsavverkning,
            kod: Avverkningsformer.ForyngringsavverkningKod
        },
        {
            namn: Avverkningsformer.Gallring,
            kod: Avverkningsformer.GallringKod
        },
        {
            namn: Avverkningsformer.Okand,
            kod: Avverkningsformer.OkandKod
        }
    ];
}

export class AvverkningsanmalanSkogstyper {
    static readonly normalskog = "Normalskog";
    static readonly adellov = "Ädellöv";
    static readonly fjallnara = "Fjällnära skog";
}

export class Arbetsordertyper {
    static readonly Avverkning = "Avverkning";
    static readonly Grotskotning = "Grotskotning";
    static readonly IngenProduktion = "Ingen produktion";
}

export class KartgeometriKategori {
    static readonly Virkeskop = "Virkeskop";
    static readonly Arbetsorder = "Arbetsorder";
}

export class AvverkningsgruppForkortning {
    static readonly Gallring = "GA";
    static readonly OvrigAvverkning = "ÖA";
    static readonly Foryngringsavverkning = "FA";
    static readonly Energived = "EN";
    static readonly NSAvverkning = "NS";
    static readonly Leveransvirke = "LEV";
    static readonly Grot = "Grot";
    static readonly Kombinerad = "KOMB";
    static readonly HyggesfriAvverkning = "HF";
}

export class Avverkningsgrupper {
    static readonly Gallring = "Gallring";
    static readonly OvrigAvverkning = "Övrig avverkning";
    static readonly Foryngringsavverkning = "Föryngringsavverkning";
    static readonly Energived = "Energived";
    static readonly Leveransvirke = "Leveransvirke";
    static readonly Grotskotning = "Grotskotning";
    static readonly NSAvverkning = "NS-avverkning";
    static readonly HyggesfriAvverkning = "Hyggesfri avverkning";
}

export class Atgardstyp {
    static readonly GallringOspecificerad = "G ospec";
    static readonly Kvalitetsgallring = "G kval";
    static readonly Laggallring = "G lag";
    static readonly Hushallsgallring = "G hush";
    static readonly Klengallring = "G klen";
    static readonly UtglesningFS = "Utgl F/S";
    static readonly AvvecklingFS = "Avv F/S";
    static readonly Plockhuggning = "Plockh";
    static readonly Bladning = "Blädn";
    static readonly VindSkada = "Vind/Skada";
    static readonly VagLedning = "Väg/Ledn";
    static readonly NSFrihuggning = "NS-Frihuggning";
    static readonly NSUtglesning = "NS-Utglesning";
    static readonly NSLuckhuggning = "NS-Luckhuggning";
    static readonly NSRestavv = "NS-Restavv";
    static readonly Foryngringsavverkning = "Favv";
    static readonly ForyngringsavverkningTillFrotrad = "Favv F";
    static readonly ForyngringsavverkningTillSkarm = "Favv S";
    static readonly Kanthuggning = "Kanth";
    static readonly Luckhuggning = "Luckh";
    static readonly FrakAvv = "Frak-avv";
    static readonly Grot = "Grot";
    static readonly Energived = "Energived";
    static readonly BiobransleLangsVag = "Biobr väg";
    static readonly Leveransvirke = "Leveransvirke";
    static readonly SkadaPlockhuggning = "Skada Plockh";
    static readonly SchackruteavverkningHF = "Schack-avv";
    static readonly BladningHF = "Bladn HF";
    static readonly PlockhuggningHF = "Plockh HF";
    static readonly AvverkningtillskarmHF = "Avv S HF";
    static readonly UtglesningavskarmHF = "HF-Utglesning";
    static readonly AvvecklingavskarmHF = "HF-Avveckling";
    static readonly GallringHF = "Gall-HF";
    static readonly KanthuggningHF = "Kanthuggning HF";
    static readonly LuckhuggningHF = "Luckhuggning HF";

    static readonly alla = [
        Atgardstyp.GallringOspecificerad,
        Atgardstyp.Kvalitetsgallring,
        Atgardstyp.Laggallring,
        Atgardstyp.Hushallsgallring,
        Atgardstyp.Klengallring,
        Atgardstyp.UtglesningFS,
        Atgardstyp.AvvecklingFS,
        Atgardstyp.Plockhuggning,
        Atgardstyp.Bladning,
        Atgardstyp.VindSkada,
        Atgardstyp.VagLedning,
        Atgardstyp.NSFrihuggning,
        Atgardstyp.NSUtglesning,
        Atgardstyp.NSLuckhuggning,
        Atgardstyp.NSRestavv,
        Atgardstyp.Foryngringsavverkning,
        Atgardstyp.ForyngringsavverkningTillFrotrad,
        Atgardstyp.ForyngringsavverkningTillSkarm,
        Atgardstyp.Kanthuggning,
        Atgardstyp.Luckhuggning,
        Atgardstyp.FrakAvv,
        Atgardstyp.Grot,
        Atgardstyp.Energived,
        Atgardstyp.BiobransleLangsVag,
        Atgardstyp.Leveransvirke,
        Atgardstyp.SkadaPlockhuggning,
        Atgardstyp.SchackruteavverkningHF,
        Atgardstyp.BladningHF,
        Atgardstyp.PlockhuggningHF,
        Atgardstyp.AvverkningtillskarmHF,
        Atgardstyp.UtglesningavskarmHF,
        Atgardstyp.AvvecklingavskarmHF,
        Atgardstyp.GallringHF,
        Atgardstyp.KanthuggningHF,
        Atgardstyp.LuckhuggningHF
    ];

    static readonly foryngringsavverkningstyper = [
        Atgardstyp.Foryngringsavverkning,
        Atgardstyp.ForyngringsavverkningTillFrotrad,
        Atgardstyp.ForyngringsavverkningTillSkarm,
        Atgardstyp.Kanthuggning,
        Atgardstyp.Luckhuggning,
        Atgardstyp.FrakAvv
    ];

    static readonly markberedningbForyngringTyper = [
        Atgardstyp.Foryngringsavverkning,
        Atgardstyp.ForyngringsavverkningTillFrotrad,
        Atgardstyp.ForyngringsavverkningTillSkarm,
        Atgardstyp.VagLedning,
        Atgardstyp.Kanthuggning,
        Atgardstyp.FrakAvv,
        Atgardstyp.Luckhuggning,
        Atgardstyp.VindSkada,
        Atgardstyp.NSFrihuggning,
        Atgardstyp.NSUtglesning,
        Atgardstyp.NSLuckhuggning,
        Atgardstyp.NSRestavv
    ];

    static readonly avvAnmalanTyper = [
        Atgardstyp.VagLedning,
        Atgardstyp.UtglesningFS,
        Atgardstyp.VindSkada,
        Atgardstyp.NSFrihuggning,
        Atgardstyp.NSUtglesning,
        Atgardstyp.NSLuckhuggning,
        Atgardstyp.NSRestavv,
        Atgardstyp.Foryngringsavverkning,
        Atgardstyp.ForyngringsavverkningTillFrotrad,
        Atgardstyp.ForyngringsavverkningTillSkarm,
        Atgardstyp.Kanthuggning,
        Atgardstyp.Luckhuggning,
        Atgardstyp.FrakAvv
    ];
}

export class CertifikatTyper {
    static readonly Fsc = "FSC";
    static readonly Pefc = "PEFC";
    static readonly Ocertifierat = "Ocertifierat";

    static readonly alla = [
        CertifikatTyper.Fsc,
        CertifikatTyper.Pefc,
        CertifikatTyper.Ocertifierat
    ];
    static readonly allaCertifierbaraTyper = [
        CertifikatTyper.Fsc,
        CertifikatTyper.Pefc
    ];
}

export class ProduktFordelningsmatrisTyper {
    static readonly forbjuden = "FORBJUDEN";
    static readonly min = "MIN";
    static readonly max = "MAX";
    static readonly inget = "INGET";
}

export class Befraktare {
    static readonly sveaskog = "77788-00000";
}

export class TplMapLayerConstats {
    static readonly ruttLayerName = "RuttLayer";

    static readonly bk1PrimaryRouteColor = "#3988ff";
    static readonly bk4PrimaryRouteColor = "#5C2D91";

    static readonly bkInactiveRouteColor = "#979797";
}

export enum TransportomradenConstats {
    Rundvirke = 1,
    Bransle = 2
}

export class Kapkriteria {
    static readonly ingaBegransningar = "Inga begränsningar";
    static readonly endastManuellaKap = "Endast manuella kap";
    static readonly endastVardeaptering = "Endast värdeaptering";
    static readonly forbjudetAttKapa = "Förbjudet att kapa";
}

export class ExternArbetsorderStatus {
    static readonly Ok = "Ok";
    static readonly Fel = "Fel";
    static readonly Ignorerad = "Ignorerad";
    static readonly EjBeraknad = "Ej beräknad";
    static readonly Inaktiv = "Inaktiv";

    static readonly Alla: any[] = [
        this.Ok,
        this.Fel,
        this.Ignorerad,
        this.EjBeraknad,
        this.Inaktiv
    ];
    static readonly StatusarForSokning: any[] = [
        {
            key: this.Ok,
            value: "Hanterad"
        },
        {
            key: this.Fel,
            value: "Fel"
        },
        {
            key: this.EjBeraknad,
            value: "Ej hanterad"
        }
    ];
}

export class ProduktinstruktionValidationScope {
    static readonly Inget = 0;
    static readonly Spara = 1;
    static readonly Publicera = 2;
    static readonly Masseditera = 4;

    // eslint-disable-next-line no-bitwise
    static readonly Alla = ProduktinstruktionValidationScope.Spara | ProduktinstruktionValidationScope.Publicera;
}

export class ArbetsorderWorkTypeConstants {
    static readonly utbytessimulera = "utbytessimulera";
    static readonly arbetsorderWorkStarted = "viol2.spegla.started";
    static readonly arbetsorderWorkRequested = "viol2.spegla.requested";
    static readonly destineringsalternativWorkArbetsorder = "destineringsalternativ.arbetsorder";
}

export class ActivityStatus {
    static readonly Ok = "Ok";
    static readonly Fel = "Fel";
    static readonly Pagaende = "Pågående";
}

export class RaskSagas {
    static readonly SendArbetsorderToViol3Saga = "SendArbetsorderToViol3Saga";
}

export class VisibleSagas {
    static readonly Alla: string[] = [RaskSagas.SendArbetsorderToViol3Saga];
}

export class CollectorImportKalla {
    static readonly Fieldmaps = "Fieldmaps";
    static readonly Springfield = "Springfield";
}

export class VkKartaLayerNames {
    static readonly virkeskopsatgardLayer = "virkeskopsatgardlayer";
    static readonly levvirkeLayer = "levvirkelayer";
    static readonly skogsvardatgardLayer = "skogsvardatgardlayer";
    static readonly importLayer = "importLayer";
    static readonly ritunderlagLayer = "ritunderlaglayer";
}

export class KartaFeaturelayers {
    static readonly Destineringsomradeytor = "Destineringsområdeytor";
    static readonly Satellitbilder = "Satellitbilder";
    static readonly Drone = "Drone";
    static readonly SmittadZonSjv = "smittad_zon_sjv";

    static readonly Naturhansyn = "Naturhansyn";
    static readonly Collector = "Collector";
    static readonly Arboreal = "Arboreal";
    static readonly Virkeskop = "Virkeskop";
    static readonly Virkeskop_historiska = "Virkeskop_historiska";
    static readonly MetriaFastighetsgranser = "MetriaFastighetsgranser";
    static readonly Restriktioner = "Restriktioner";
    static readonly FornKulturminnen = "FornKulturminnen";
    static readonly VerkGemAdminGrans = "VerkGemAdminGrans";
    static readonly VerkGemLLD = "VerkGemLLD";
    static readonly VerkGemFastigheter = "VerkGemFastigheter";
    static readonly VerkGemSamfalligheter = "VerkGemSamfalligheter";
    static readonly VerkGemLKF = "VerkGemLKF";
    static readonly VerkGemFaktaExternVindkraft = "VerkGemFaktaExternVindkraft";
    static readonly VerkGemFaktaBelastningar = "VerkGemFaktaBelastningar";
    static readonly Vagar = "Vagar";
    static readonly VFS_PlaneradVag = "VFS_PlaneradVag";
    static readonly Laserprodukter = "Laserprodukter";
    static readonly AllmannaYtorLinjerPunkter = "Allmanna_ytor_linjer_punkter";
    static readonly Destineringsomraden = "Destineringsomraden";
    static readonly Atgarder = "Atgarder";
    static readonly AtgarderSelection = "Atgarder_selection";
    static readonly EgenSkog = "Egen_skog";
    static readonly StinaKorstrak = "StinaKorstrak";
    static readonly StinaGrotpunkter = "StinaGrotpunkter";
    static readonly StinaHansyn = "StinaHansyn";
    static readonly StinaEgenritadeObjekt = "StinaEgenritadeObjekt";
    static readonly RaskMottagningsplatser = "RaskMottagningsplatser";
    static readonly Springfield = "Springfield";
    static readonly SKS_Avverkningsanmalningar = "SKS_Avverkningsanmalningar";
    static readonly SKS_UtfordAvverkning = "SKS_UtfordAvverkning";
    static readonly Renskotselomraden = "Renskotselomraden";
    static readonly Historto = "Historto";
    static readonly Infrarodorto = "Infrarodorto";
}

export class SkogsvardAtgardsGrupp {
    static readonly markberedning = "Markberedning";
    static readonly foryngring = "Föryngring";
    static readonly rojning = "Röjning";
    static readonly plantleverans = "Plantleverans";
    static readonly inventering = "Inventering";
    static readonly ovrigt = "Övrigt";
    static readonly Alla: string[] = [
        SkogsvardAtgardsGrupp.markberedning,
        SkogsvardAtgardsGrupp.foryngring,
        SkogsvardAtgardsGrupp.rojning,
        SkogsvardAtgardsGrupp.plantleverans,
        SkogsvardAtgardsGrupp.inventering,
        SkogsvardAtgardsGrupp.ovrigt
    ];

    /**
     * Föryngring och Plantleverans hör ihop och visas tillsammans.
     * Avgör om en given åtgärdsgrupp matchar den valda gruppen.
     */
    static matchesGrupp(atgardsGrupp: string, selectedGrupp: string): boolean {
        if (selectedGrupp === SkogsvardAtgardsGrupp.foryngring) {
            return atgardsGrupp === SkogsvardAtgardsGrupp.foryngring || atgardsGrupp === SkogsvardAtgardsGrupp.plantleverans;
        }
        return atgardsGrupp === selectedGrupp;
    }
}

export class SVPSkogsvardAtgardsGrupp {
    static readonly mb = "MB";
    static readonly foryngring = "FORYNGRING";
    static readonly inventering = "INVENTERING";
    static readonly rojning = "ROJNING";
    static readonly ovrigt = "OVRIGT";
    static readonly plantleverans = "PH";

    static readonly Alla: string[] = [
        SkogsvardAtgardsGrupp.markberedning,
        SkogsvardAtgardsGrupp.foryngring,
        SkogsvardAtgardsGrupp.rojning,
        SkogsvardAtgardsGrupp.plantleverans,
        SkogsvardAtgardsGrupp.inventering,
        SkogsvardAtgardsGrupp.ovrigt
    ];
}

export class SkogsvardAtgardsTyp {
    static readonly intermittentMarkberedning = "Intermittent markberedning";
    static readonly riktadMarkberedning = "Riktad markberedning";
    static readonly kontinuerligMarkberedning = "Kontinuerlig markberedning";
    static readonly markberedningSadd = "Markberedning sådd";
    static readonly dikesrensning = "Dikesrensning";
    static readonly plantering = "Plantering";
    static readonly hjalpplantering = "Hjälpplantering";
    static readonly siktrojning = "Siktröjning";
    static readonly nsSiktrojning = "NS-siktröjning";
    static readonly hyggesrensning = "Hyggesrensning";
    static readonly plantleverans = "Plantleverans";
    static readonly nsRojning = "NS-röjning";
    static readonly plantrojning = "Plantröjning";
    static readonly slutrojning = "Slutröjning";
    static readonly foryngringSadd = "Sådd";
    static readonly foryngringViltskydd = "Viltskydd";
    static readonly foryngringsInventering = "Föryngringsinventering";
    static readonly atervaxtkontroll = "Återväxtkontroll";
    static readonly ovrigt = "Övrigt";
}

// Dessa värden måste följa json-schemat för api:t och är case sensitive
// --
export class SkogsvardForyngringssatt {
    static readonly naturligForyngring = "Naturlig föryngring";
    static readonly sadd = "Sådd";
    static readonly plantering = "Plantering";
}

export class SkogsvardSkonsamMarkbehandling {
    static readonly nej = "Nej";
    static readonly ja20 = "Ja 20%";
    static readonly ja40 = "Ja 40%";
}

export class SkogsvardKornstorlek {
    static readonly grov = "Grov";
    static readonly medel = "Medel";
    static readonly fin = "Fin";
}

export class SkogsvardMarkfuktighet {
    static readonly torr = "Torr";
    static readonly frisk = "Frisk";
    static readonly fuktig = "Fuktig";
    static readonly blot = "Blöt";
}

export class SkogsvardMeddelasMarkagare {
    static readonly sms = "SMS";
    static readonly epost = "Epost";
    static readonly epostOchSms = "Epost och SMS";
    static readonly skickaInte = "Skicka inte";
}
// --
export class SkogsvardBetalningstyp {
    static readonly likvid = "Likvid";
    static readonly faktura = "Faktura";
}
export class SkogsvardMattslagsTyper {
    static readonly timme = "timme";
    static readonly ha = "ha";
}

// Vi kan lägga till alla här vid behov
export class SkogsvardAtgardsMetod {
    static readonly motormanuell = "Motormanuell";
    static readonly objektiv = "Objektiv";
}

export class EntityType {
    static readonly virkeskopsAtgardSkogsvard = "virkeskopsatgardSkogsvard";
    static readonly virkeskopsAtgard = "virkeskopsatgard";
    static readonly virkeskopsAtgardLeveransvirke = "virkeskopsatgardLeveransvirke";
}

export class Kostnadstyper {
    static readonly DirektAvverkningskostnad = "Direkt avverkningskostnad";
    static readonly IndirektAvverkningskostnad = "Indirekt avverkningskostnad";
}

export class StatiskaProduktionsomradeIdn {
    static readonly bergslagenVast = 26;
}

export class Mottagningsplatstyper {
    static readonly Mottagningsplats = "Mottagningsplats";
    static readonly Hamtplats = "Hämtplats";

    static readonly Alla = [
        Mottagningsplatstyper.Mottagningsplats,
        Mottagningsplatstyper.Hamtplats
    ];
}

export class JobbStatus {
    static readonly ny = "Ny";
    static readonly felUppehall = "FelUppehall";
    static readonly behandlas = "Behandlas";
    static readonly behandlad = "Behandlad";
    static readonly fel = "Fel";
    static readonly forsokIgen = "ForsokIgen";
    static readonly ignorerad = "Ignorerad";
}

export class BYL {
    static readonly barighetItems: SimpleSelectionItem[] = [
        {
            id: "1",
            value: 1,
            text: "1 Mycket god"
        },
        {
            id: "2",
            value: 2,
            text: "2 God"
        },
        {
            id: "3",
            value: 3,
            text: "3 Medelgod"
        },
        {
            id: "4",
            value: 4,
            text: "4 Dålig"
        },
        {
            id: "5",
            value: 5,
            text: "5 Mycket dålig"
        }
    ];

    static readonly ytstrukturItems: SimpleSelectionItem[] = [
        {
            id: "1",
            value: 1,
            text: "1 Ytblock saknas"
        },
        {
            id: "2",
            value: 2,
            text: "2 Liten förekomst"
        },
        {
            id: "3",
            value: 3,
            text: "3 Måttlig förekomst"
        },
        {
            id: "4",
            value: 4,
            text: "4 Hög förekomst"
        },
        {
            id: "5",
            value: 5,
            text: "5 Mycket hög förekomst"
        }
    ];

    static readonly lutningItems: SimpleSelectionItem[] = [
        {
            id: "1",
            value: 1,
            text: "1 Lutning < 5%"
        },
        {
            id: "2",
            value: 2,
            text: "2 Lutning > 5% < 15%"
        },
        {
            id: "3",
            value: 3,
            text: "3 Lutning > 15% < 34%"
        },
        {
            id: "4",
            value: 4,
            text: "4 Lutning > 35% < 50%"
        },
        {
            id: "5",
            value: 5,
            text: "5 Lutning > 50%"
        }
    ];
}

export class VirkeskopBlobStorageTyp {
    static readonly SkogsvardBilaga = "Skogsvard-bilaga";
    static readonly NvbBilaga = "NVB-bilaga";
    static readonly AvverkningsanmalanSamradBilaga = "AvverkningsanmalanSamrad-bilaga";
    static readonly RitunderlagBilaga = "Ritunderlag-bilaga";
}

export enum VirkeskopDokumentTyp {
    Kontrakt = 0,
    Arbetsorder = 1,
    Betalplan = 2
}

export class DokumentTyp {
    static readonly Kontrakt = "Kontrakt";
    static readonly SkogsvardsKontrakt = "SkogsvardsKontrakt";
    static readonly Avverkningsdirektiv = "Avverkningsdirektiv";
}

export class Dokumentstatus {
    static readonly Utkast = "Utkast";
    static readonly Gallande = "Gällande";
}

export class Kontakter {
    static readonly PersOrgnummerRegularExpression = "^(19|20|){1}[0-9]{6}[-][0-9]{4}$";
    static readonly OrgnummerRegularExpression = "^\\d{6}-\\d{4}$";
    static readonly PersnummerRegularExpression = "^(19|20)\\d{6}-\\d{4}$";
    static readonly EpostRegularExpression = "^[^\\s@.]+(?:\\.[^\\s@.]+)*@(?:[^\\s@.]+\\.)+[^\\s@.]{2,}$";
}

export class SkogsvardsStatus {
    static readonly ny = "Ny";
    static readonly planerbar = "Planerbar";
    static readonly planering = "Planering";
    static readonly tilldelad = "Tilldelad";
    static readonly delgiven = "Delgiven";
    static readonly tillganglig = "Tillgänglig";
    static readonly utford = "Utförd";
    static readonly slutrapporterad = "Slutrapporterad";
    static readonly godkand = "Godkänd";
    static readonly ajourhallen = "Ajourhållen";
    static readonly ejGodkand = "Ej godkänd";
    static readonly ejUtford = "Ej utförd";
    static readonly borttagen = "Borttagen";
    static readonly alla: string[] = [
        SkogsvardsStatus.ny,
        SkogsvardsStatus.planerbar,
        SkogsvardsStatus.planering,
        SkogsvardsStatus.tilldelad,
        SkogsvardsStatus.delgiven,
        SkogsvardsStatus.tillganglig,
        SkogsvardsStatus.utford,
        SkogsvardsStatus.slutrapporterad,
        SkogsvardsStatus.godkand,
        SkogsvardsStatus.ajourhallen,
        SkogsvardsStatus.ejGodkand,
        SkogsvardsStatus.ejUtford,
        SkogsvardsStatus.borttagen
    ];

    static readonly innanTillganglig: string[] = [
        SkogsvardsStatus.ny,
        SkogsvardsStatus.planerbar,
        SkogsvardsStatus.planering,
        SkogsvardsStatus.tilldelad,
        SkogsvardsStatus.delgiven
    ];
}

export class VirkeskopKontraktstatus {
    static readonly Anbud = "Anbud";
    static readonly EjKopt = "Ej köpt";
    static readonly Vilande = "Vilande";
    static readonly Kontrakt = "Kontrakt";
    static readonly Makulerat = "Makulerat";
}

export class EudrRaskStatuses {
    static readonly submitted = "Väntande";
    static readonly available = "Tillgänglig";
    static readonly withdrawn = "Återkallad";
}

export class DrivningspunktTyper {
    static readonly larmpunkt = "Larmpunkt";
    static readonly avlagg = "Avlägg";
}

export class DigitalSignaturStatus {
    static readonly draft = "Draft";
    static readonly pending = "Pending";
    static readonly signed = "Signed";
    static readonly declined = "Declined";
    static readonly canceled = "Canceled";
    static readonly overdue = "Overdue";
}

export class DigitalSignaturDeltagareStatus {
    static readonly unknown = "Unknown";
    static readonly signed = "Signed";
    static readonly declined = "Declined";
}

export class DigitalSignaturDeltagareTyper {
    static readonly leverantor = "Leverantor";
    static readonly virkeskopare = "Virkeskopare";
    static readonly makeMaka = "MakeMaka";
    static readonly extraDeltagare = "ExtraDeltagare";
}

export class Signeringsmetoder {
    static readonly bankid = "Bankid";
    static readonly sms = "SMS";
    static readonly attest = "Attest";
    static readonly alla: string[] = [
        this.bankid,
        this.sms,
        this.attest
    ];
}

export class Svar {
    static readonly ja = "Ja";

    static readonly nej = "Nej";

    static readonly tomt = "-";
    static readonly alla: string[] = [
        Svar.ja,
        Svar.nej,
        Svar.tomt
    ];
}

export class Transportslag {
    static readonly IngenTransport = "Ingen transport";
    static readonly Vag = "Vägtransport";
    static readonly Sjo = "Sjötransport";
    static readonly Jarnvag = "Järnvägstransport";
    static readonly alla: string[] = [
        Transportslag.Vag,
        Transportslag.Sjo,
        Transportslag.Jarnvag,
        Transportslag.IngenTransport
    ];
    static readonly allaMedTransport = [
        Transportslag.Vag,
        Transportslag.Sjo,
        Transportslag.Jarnvag
    ];
}

export class Forstaledskontraktstyp {
    static readonly Avgangsmatning = "Avgångsmätning";
    static readonly Transport = "Transport";
    static readonly Ankomstmatning = "Ankomstmätning";
    static readonly AvgangsmatningUtanTransport = "AvgångsmätningUtanTransport";
    static readonly alla: string[] = [
        Forstaledskontraktstyp.Avgangsmatning,
        Forstaledskontraktstyp.Transport,
        Forstaledskontraktstyp.Ankomstmatning,
        Forstaledskontraktstyp.AvgangsmatningUtanTransport
    ];
}

export class Malklass {
    static readonly NONS = "NO_NS";
    static readonly ProduktionMedGenerellHansyn = "PG";
    static readonly ProduktionMedForstarktHansyn = "PF";
    static readonly NaturvardsmalMedSkotsel = "NS";
    static readonly NaturvardsmalOrort = "NO";
    static readonly Kval = "KVAL";
    static readonly allaValbara: string[] = [
        Malklass.ProduktionMedGenerellHansyn,
        Malklass.ProduktionMedForstarktHansyn,
        Malklass.NaturvardsmalMedSkotsel
    ];
}

export class RestriktionsTyper {
    static readonly ARTRIKVAGKANT = "Artrik vägkant";
    static readonly ARTSKYDD = "Artskydd";
    static readonly AVLAGGALLMANVAG = "Avlägg allmän väg";
    static readonly FORNLAMNING = "Fornlämning";
    static readonly KULTURLAMNING = "Kulturlämning";
    static readonly LEDNING = "Ledning";
    static readonly MILSKJUTFALT = "Militärt skjutfält";
    static readonly RENHANSYN = "Rennäring hänsyn";
    static readonly SOCHANSYN = "Sociala hänsyn";
    static readonly TORVDRIVNING = "Torvdrivning";
    static readonly VATTENSKYDDSOMR = "Vattenskyddsområde";
    static readonly VINDKRAFTSPARK = "Vindkraftspark";
    static readonly VINTERVAG = "Vinterväg";
    static readonly FORSOKSOMRADESKOGLIGTFORSOK = "Försöksområde/skogligt försök";

    static readonly AllaWithKey: { key: string; value: string }[] =
        [
            {
                key: "ARTRIKVAGKANT",
                value: RestriktionsTyper.ARTRIKVAGKANT
            },
            {
                key: "ARTSKYDD",
                value: RestriktionsTyper.ARTSKYDD
            },
            {
                key: "AVLAGGALLMANVAG",
                value: RestriktionsTyper.AVLAGGALLMANVAG
            },
            {
                key: "FORNLAMNING",
                value: RestriktionsTyper.FORNLAMNING
            },
            {
                key: "KULTURLAMNING",
                value: RestriktionsTyper.KULTURLAMNING
            },
            {
                key: "LEDNING",
                value: RestriktionsTyper.LEDNING
            },
            {
                key: "MILSKJUTFALT",
                value: RestriktionsTyper.MILSKJUTFALT
            },
            {
                key: "RENHANSYN",
                value: RestriktionsTyper.RENHANSYN
            },
            {
                key: "SOCHANSYN",
                value: RestriktionsTyper.SOCHANSYN
            },
            {
                key: "TORVDRIVNING",
                value: RestriktionsTyper.TORVDRIVNING
            },
            {
                key: "VATTENSKYDDSOMR",
                value: RestriktionsTyper.VATTENSKYDDSOMR
            },
            {
                key: "VINDKRAFTSPARK",
                value: RestriktionsTyper.VINDKRAFTSPARK
            },
            {
                key: "VINTERVAG",
                value: RestriktionsTyper.VINTERVAG
            },
            {
                key: "FORSOKSOMRADESKOGLIGTFORSOK",
                value: RestriktionsTyper.FORSOKSOMRADESKOGLIGTFORSOK
            }
        ];
}

export class ArbetsorderRestriktionStatus {
    static readonly Hanterad = "Hanterad";
    static readonly Ejhanterad = "Ej hanterad";

    static readonly Pagar = "Pågår";
    static readonly alla: string[] = [
        ArbetsorderRestriktionStatus.Ejhanterad,
        ArbetsorderRestriktionStatus.Pagar,
        ArbetsorderRestriktionStatus.Hanterad
    ];
}

export class ConfirmDialogResponse {
    static readonly save = "save";
    static readonly cancel = "cancel";
}

export class MarknadsprislistaTyp {
    static readonly Viol2 = "Viol2";
    static readonly Viol3 = "Viol3";
    static readonly Skordarmatning = "Skordarmatning";

    static readonly AllaWithKeys: Dictionary<string> = {
        Viol2: "Viol 2",
        Viol3: "Viol 3",
        Skordarmatning: "Skördarmätning"
    };
}

export enum Environments {
    Dev = "DEV",
    Utv = "UTV",
    Test = "TEST",
    Demo = "DEMO",
    AccTest = "ACCTEST",
    Prod = "PROD"
}

interface Dictionary<T> {
    [key: string]: T;
}

export class ErsattningsgrundandeMatning {
    static readonly Skordarmatning = "Skördarmätning";
    static readonly Industrimatning = "Industrimätning";

    static readonly alla: string[] = [
        ErsattningsgrundandeMatning.Skordarmatning,
        ErsattningsgrundandeMatning.Industrimatning
    ];
}
